import { ThinPublisher } from "src/app/shared/_models/models";

export type PublisherDescription = Pick<ThinPublisher, 'publisherId' | 'publisherName'>;